import React, { useState, useEffect } from 'react'
import {
  Panel,
  Message,
  Row,
  Input,
  ControlLabel,
  Col,
  Table,
  IconButton,
  Icon,
  ButtonToolbar,
  SelectPicker,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import InputForm from '../../../components/forms/input/InputForm'
import InputSelectForm from '../../../components/forms/input/InputSelectForm'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { useHistory } from 'react-router-dom'
import pathname from '../../../constants/pathname'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import { exportVender, searchProjectVender } from '../../../redux/actions/adminReport'
import { downloadFile } from '../../../utils/fileUtil'

export default function ProjectVenderListsWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const { Column, HeaderCell, Cell, Pagination } = Table
  const history = useHistory()
  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 10, label: 10 },
    { value: 20, label: 20 },
    { value: 30, label: 30 },
    { value: 40, label: 40 },
    { value: 50, label: 50 },
  ]

  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [dataTable, setDataTable] = useState()
  const [errorMsg, setErrorMsg] = useState()
  const [condition, setCondition] = useState()
  const [pagSize, setPagSize] = useState(10)
  const [clearValue, setClearValue] = useState(false)
  const [lengthMenu, setLengthMenu] = useState()
  const [page, setPage] = useState(1)
  const [displayLength, setDisplayLength] = useState(formSchema.displayLength || 10)
  const [viewSize, setViewSize] = useState([])

  useEffect(() => {
    // console.log('formSchema => ', formSchema)
    setDataTable(props.schema.values)
    setViewSize(defaultLengthMenu)
  }, [])

  const handleChangePage = (dataKey) => {
    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(displayLength, dataKey)
    }
  }

  const handleChangeLength = (dataKey) => {
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(dataKey, 1)
    }
  }

  const onReload = (display, pages) => {
    setValue(formSchema.searchForm.projectCode.name, '')
    setValue(formSchema.searchForm.contractCode.name, '')
    setValue(formSchema.searchForm.venderName.name, '')
    setValue(formSchema.searchForm.venderType.name, '')
    setValue(formSchema.searchForm.venderStatus.name, '')
    setValue(formSchema.searchForm.venderAccStatus.name, '')

    const request = {
      projectCode: '',
      contractCode: '',
      venderName: '',
      venderType: '',
      venderStatus: '',
      accStatus: '',
    }

    callApiSearchProjectVender(pages, display, request)
  }

  const onSubmit = (data) => {
    console.log('onSubmit => ', data)

    // return false

    const request = {
      projectCode: data.projectCode,
      contractCode: data.contractCode,
      venderName: data.venderName,
      venderType: data.venderType,
      venderStatus: data.venderStatus,
      accStatus: data.venderAccStatus,
    }

    callApiSearchProjectVender(1, 10, request)
  }

  const onSubmitExport = (data) => {
    console.log('onSubmitExport => ', data)

    const request = {
      projectCode: data.projectCode,
      contractCode: data.contractCode,
      venderName: data.venderName,
      venderType: data.venderType,
      venderStatus: data.venderStatus,
      accStatus: data.venderAccStatus,
    }

    handleExportFile(request)
  }

  const handleExportFile = async (request) => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const file = await exportVender(request)

      if (file) {
        downloadFile(file, file.name || `ตรวจสอบข้อมูลเวนเดอร์`)
      }
    } catch (e) {
      console.error('err => ', e)
      // let errorJson = JSON.parse(await e.response.data.text())
      // setIsError(true)
      // handelSetErrorMsg('error', errorJson?.errors?.message)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onCancel = (data) => {
    setValue(formSchema.searchForm.projectCode.name, '')
    setValue(formSchema.searchForm.contractCode.name, '')
    setValue(formSchema.searchForm.venderName.name, '')
    setValue(formSchema.searchForm.venderType.name, '')
    setValue(formSchema.searchForm.venderStatus.name, '')
    setValue(formSchema.searchForm.venderAccStatus.name, '')

    const request = {
      projectCode: '',
      contractCode: '',
      venderName: '',
      venderType: '',
      venderStatus: '',
      accStatus: '',
    }

    callApiSearchProjectVender(1, 10, request)
  }

  const callApiSearchProjectVender = async (pageNumber, pageSize, request) => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await searchProjectVender(pageNumber, pageSize, request)
      // console.log('schema ', _schema.model.forms)
      if (_schema.success) {
        // setFormSchema(_schema.model.forms)
        setDataTable(_schema.model.forms.values)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      {formSchema && (
        <Panel
          shaded
          header={formSchema.header}
          collapsible
          defaultExpanded
          ref={(section) => {
            setSection(section)
          }}
        >
          {isLoading && <OverlayLoader />}

          <div style={{ paddingRight: 80, paddingLeft: 80, paddingBottom: 40 }}>
            <Row>
              {formSchema?.searchForm?.projectCode && (
                <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
                  <ControlLabel>{formSchema.searchForm.projectCode.label}</ControlLabel>
                  <Input
                    name={formSchema.searchForm.projectCode.name}
                    defaultValue={formSchema.searchForm.projectCode.value}
                    placeholder={formSchema.searchForm.projectCode.label || `ระบุรหัสโครงการ`}
                    inputRef={register()}
                  />
                </Col>
              )}
              {formSchema?.searchForm?.contractCode && (
                <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
                  <ControlLabel>{formSchema.searchForm.contractCode.label}</ControlLabel>
                  <Input
                    name={formSchema.searchForm.contractCode.name}
                    defaultValue={formSchema.searchForm.contractCode.value}
                    placeholder={formSchema.searchForm.contractCode.label || `ระบุเลขที่สัญญา`}
                    inputRef={register()}
                  />
                </Col>
              )}
              {formSchema?.searchForm?.venderName && (
                <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
                  <ControlLabel>{formSchema.searchForm.venderName.label}</ControlLabel>
                  <Input
                    name={formSchema.searchForm.venderName.name}
                    defaultValue={formSchema.searchForm.venderName.value}
                    placeholder={formSchema.searchForm.venderName.label || `ระบุชื่อเวนเดอร์`}
                    inputRef={register()}
                  />
                </Col>
              )}

              {formSchema?.searchForm?.venderType && (
                <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
                  <ControlLabel>{formSchema.searchForm.venderType.label}</ControlLabel>
                  <Controller
                    name={formSchema.searchForm.venderType.name}
                    control={control}
                    defaultValue={formSchema.searchForm.venderType.value}
                    render={(props) => {
                      return (
                        <SelectPicker
                          searchable={false}
                          data={formSchema.searchForm.venderType.options}
                          value={props.value}
                          block
                          placeholder="เลือก"
                          onChange={(value) => {
                            props.onChange(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              )}

              {formSchema?.searchForm?.venderStatus && (
                <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
                  <ControlLabel>{formSchema.searchForm.venderStatus.label}</ControlLabel>
                  <Controller
                    name={formSchema.searchForm.venderStatus.name}
                    control={control}
                    defaultValue={formSchema.searchForm.venderStatus.value}
                    render={(props) => {
                      return (
                        <SelectPicker
                          searchable={false}
                          data={formSchema.searchForm.venderStatus.options}
                          value={props.value}
                          block
                          placeholder="เลือก"
                          onChange={(value) => {
                            props.onChange(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              )}

              {formSchema?.searchForm?.venderAccStatus && (
                <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
                  <ControlLabel>{formSchema.searchForm.venderAccStatus.label}</ControlLabel>
                  <Controller
                    name={formSchema.searchForm.venderAccStatus.name}
                    control={control}
                    defaultValue={formSchema.searchForm.venderAccStatus.value}
                    render={(props) => {
                      return (
                        <SelectPicker
                          searchable={false}
                          data={formSchema.searchForm.venderAccStatus.options}
                          value={props.value}
                          block
                          placeholder="เลือก"
                          onChange={(value) => {
                            props.onChange(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              )}
            </Row>

            <Row style={{ marginTop: 15 }}>
              <Col lg={24} md={24} sm={24} xs={24}>
                {/* <hr /> */}
                {formSchema?.searchForm?.searchButtonName && (
                  <SaveButton
                    children={formSchema.searchForm.searchButtonName}
                    onClick={handleSubmit(onSubmit)}
                  />
                )}

                {formSchema?.searchForm?.cancelButtonName && (
                  <CancelButton
                    children={formSchema.searchForm.cancelButtonName}
                    onClick={handleSubmit(onCancel)}
                  />
                )}
              </Col>
            </Row>
          </div>

          <div>
            {formSchema?.searchForm?.excelButtonName && (
              <Row>
                <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <SaveButton
                    icon="file-excel-o"
                    children={formSchema.searchForm.excelButtonName}
                    onClick={handleSubmit(onSubmitExport)}
                  />
                </Col>
              </Row>
            )}

            <Table
              height={400}
              data={dataTable || []}
              // onRowClick={(data) => {
              //   console.log(data)
              // }}
              wordWrap
            >
              <Column width={90} align="center">
                <HeaderCell>ลำดับ</HeaderCell>
                <Cell dataKey="rowNumber" />
              </Column>

              <Column width={150} align="center">
                <HeaderCell>รหัสโครงการ</HeaderCell>
                <Cell dataKey="projectCode" />
              </Column>

              <Column width={150} align="center">
                <HeaderCell>เลขที่ข้อตกลง</HeaderCell>
                <Cell dataKey="contractNo" />
              </Column>

              <Column minWidth={300} flexGrow={1}>
                <HeaderCell>ชื่อเวนเดอร์</HeaderCell>
                <Cell dataKey="venderName" />
              </Column>

              <Column width={180} align="center">
                <HeaderCell>ประเภทเวนเดอร์</HeaderCell>
                <Cell dataKey="venderType" />
              </Column>

              <Column width={170} align="center">
                <HeaderCell>สถานะ</HeaderCell>
                <Cell dataKey="status" />
              </Column>

              <Column width={170} align="center">
                <HeaderCell>สถานะบัญชี</HeaderCell>
                <Cell dataKey="accStatus" />
              </Column>

              <Column width={230} align="center">
                <HeaderCell>วันที่สร้าง</HeaderCell>
                <Cell dataKey="createDate" />
              </Column>

              <Column width={230} align="center">
                <HeaderCell>วันที่สร้างสำเร็จ</HeaderCell>
                <Cell dataKey="completedDate" />
              </Column>

              <Column width={120} align="center" fixed="right">
                <HeaderCell>Action</HeaderCell>

                <Cell>
                  {(rowData) => {
                    return (
                      <ButtonToolbar>
                        <IconButton
                          size="sm"
                          appearance="ghost"
                          icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                          onClick={() => {
                            sessionStorage.setItem('projectId', rowData.projectId)
                            sessionStorage.setItem('param', '')

                            history.push(`${pathname.proposal.overview.overviewCoworker}`)
                          }}
                          style={{ marginTop: -5 }}
                        >
                          แสดง{lengthMenu}
                          {/* {defaultLengthMenu} */}
                        </IconButton>
                      </ButtonToolbar>
                    )
                  }}
                </Cell>
              </Column>
            </Table>

            <TablePagination
              lengthMenu={lengthMenu || viewSize}
              activePage={page || defaultPage}
              renderLengthMenu={(lengthMenu) => {
                return (
                  <>
                    {lengthMenu}
                    {`รายการ/หน้า`}
                  </>
                )
              }}
              renderTotal={(total) => {
                return <>{` ทั้งหมด ${total || 0} รายการ`}</>
              }}
              displayLength={displayLength || 10}
              total={formSchema.totalSize || 0}
              onChangePage={handleChangePage}
              onChangeLength={handleChangeLength}
            />
          </div>
        </Panel>
      )}
    </>
  )
}
